import { render, staticRenderFns } from "./aftersale_cost_analysis.vue?vue&type=template&id=2b64ebf6&scoped=true"
import script from "./aftersale_cost_analysis.vue?vue&type=script&lang=js"
export * from "./aftersale_cost_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64ebf6",
  null
  
)

export default component.exports